import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circle3",
  "use": "icon-circle3-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-circle3\">\n<g id=\"icon-circle3_Ellipse 1451\">\n<circle id=\"icon-circle3_Ellipse 1451_2\" cx=\"6\" cy=\"6\" r=\"4.5\" stroke=\"#F7A934\" stroke-width=\"3\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/circle3.svg
// module id = EMAD
// module chunks = 103